<script>
import { mapActions } from 'vuex';
import PageImagesManage from 'components/pages/professional/shared/images/page-images-manage';

export default {
  name: 'page-stuff-to-eat-images-manage',
  mixins: [PageImagesManage],
  methods: {
    ...mapActions({
      UpdateImages: 'UpdateStuffToEatImages',
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/professional/stuff-to-eat/shared/details/images/page-stuff-to-eat-images-manage.vue